import { render } from "./HeroPreview.vue?vue&type=template&id=39da5b1f&scoped=true"
import script from "./HeroPreview.vue?vue&type=script&lang=js"
export * from "./HeroPreview.vue?vue&type=script&lang=js"

import "./HeroPreview.vue?vue&type=style&index=0&id=39da5b1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39da5b1f"]])

export default __exports__